import { Toast, toaster } from "@kobalte/core/toast"
import { Box } from "@/designSystem/components/box"
import { Icon } from "@/designSystem/components/icon"
import { toastClass } from "./toast.css"

export const toast = {
  show: (message: string) => {
    return toaster.show(props => (
      <Toast toastId={props.toastId} class={toastClass({ hue: "sand" })}>
        <Box flexDirection="row" gap="12" alignItems="center">
          {message}
        </Box>
      </Toast>
    ))
  },
  error: (message: string) => {
    return toaster.show(props => (
      <Toast toastId={props.toastId} class={toastClass({ hue: "rose" })}>
        <Box flexDirection="row" gap="12" alignItems="center">
          <Icon name="alert-triangle" color="rose400" size="18" />
          {message}
        </Box>
      </Toast>
    ))
  },
  success: (message: string) => {
    return toaster.show(props => (
      <Toast toastId={props.toastId} class={toastClass({ hue: "emerald" })}>
        <Box flexDirection="row" gap="12" alignItems="center">
          <Icon name="check-circle-2" color="emerald400" size="18" />
          {message}
        </Box>
      </Toast>
    ))
  },
}
